import { render, staticRenderFns } from "./EditCategoryDialog.vue?vue&type=template&id=986c06d4&scoped=true&"
import script from "./EditCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./EditCategoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986c06d4",
  null
  
)

export default component.exports